"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommentTextBox = exports.DialogTitle = void 0;
var dialog_title_component_1 = require("./dialog-title/dialog-title.component");
Object.defineProperty(exports, "DialogTitle", { enumerable: true, get: function () { return dialog_title_component_1.DialogTitle; } });
var comment_text_box_component_1 = require("./comment-text-box/comment-text-box.component");
Object.defineProperty(exports, "CommentTextBox", { enumerable: true, get: function () { return comment_text_box_component_1.CommentTextBox; } });
